export default __webpack_public_path__ + "static/media/13.dbbb7e80.jpg";